var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "Admin" } }, [
    !_vm.ready
      ? _c("p", [_vm._v(_vm._s(_vm.$t("message.loading")))])
      : _c(
          "section",
          { staticStyle: { padding: "10px", "font-size": "13px" } },
          [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-12" }, [
                _vm._m(0),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col-12" },
                    [
                      _c("GChart", {
                        attrs: {
                          data: _vm.chartData,
                          options: {
                            title: "ราคาสินค้าเฉลี่ย",
                            pieHole: 0.5,
                            width: 600,
                            height: 600
                          },
                          width: "800",
                          type: "PieChart"
                        }
                      })
                    ],
                    1
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-12" }, [
                _c(
                  "table",
                  { staticClass: "table", attrs: { width: "100%" } },
                  [
                    _vm._m(1),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      _vm._l(_vm.shopAvgProductPrice, function(item, index) {
                        return _c("tr", [
                          _c("td", [_vm._v(_vm._s(index + 1))]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(item.shop_name))]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(item.sku_count))]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              "~ " +
                                _vm._s(
                                  item.price_avg > 0
                                    ? item.price_avg.toFixed(0)
                                    : 0
                                )
                            )
                          ])
                        ])
                      }),
                      0
                    )
                  ]
                )
              ])
            ])
          ]
        )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-12" }, [
            _c("h4", [_vm._v("ราคาของสินค้าเฉลี่ยของแต่ละร้านค้า")])
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", { staticStyle: { "font-size": "13px" } }, [_vm._v("No.")]),
        _vm._v(" "),
        _c("th", { staticStyle: { "font-size": "13px" } }, [
          _vm._v("Shop Name")
        ]),
        _vm._v(" "),
        _c("th", { staticStyle: { "font-size": "13px" } }, [
          _vm._v("Sku Count")
        ]),
        _vm._v(" "),
        _c("th", { staticStyle: { "font-size": "13px" } }, [
          _vm._v("AVG Price")
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6e848f26", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e848f26","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/analytics/ShopAvgProductPrice.vue
// module id = null
// module chunks = 